import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {DNA} from "@dna/react";


export const useRegistrationStyles = makeStyles((theme:Theme)=>createStyles({
    titleBig:{
        marginTop:"50px",
        fontSize: "40px",
        fontWeight: 600,
        lineHeight: "48px",
        letterSpacing: "-0.005em"
    },
    sectionTitle:{
        fontWeight:600,
        fontSize:"16px",
        marginTop:"41px",
        marginBottom:"16px"
    },
    timelineTitle:{
        fontWeight:600,
        fontSize:"16px",
        marginBottom:"26px"
    },
    timelineContent:{
        display:"flex",
        flexDirection: "column"
    },
    timelineDot:{
        backgroundColor:"#EBF3FB !important"
    },
    form:{
        display:"grid",
        minWidth: "620px",
        "& .submit":{
            backgroundColor:DNA.tokens.color.turquoise.mid
        },
        "& .label":{
            fontSize:"20px",
        },
        marginBottom:16
    },
    formControl:{
         minWidth:"260px",
        paddingTop:8,
        paddingBottom: 12, 
        width: "100%"       
    },
    timeLineItemRoot:{
        marginTop:"40px"
    },
    timelineRoot:{
        paddingLeft:0
    },
    missingOppositeContent:{
        "&:before": {
            display: "none"
        }
    },
    timelineConnector:{
      width:1,
      backgroundColor:"#D2D2D2" 
    },
    disclaimer:{
        marginLeft:27
    },
    backdrop:{
        zIndex: theme.zIndex.drawer + 1
    },
    tooltipIcon: {
        marginLeft: "5px",        
        width: "16.67px",
        height: "16.67px"
    },
    requiredColor: {
        color:"red"
    }
}));